<template>
    <section class="o-section -gray-bg -front">
        <div class="o-container">
            <div class="o-row">
                <div class="o-col w-1/12 -empty"></div>
                <div class="o-col w-10/12">
                    <div class="o-text -center">
                        <h2 class="o-h3" style="margin-bottom:2.5rem;">Filtrez votre recherche</h2>
                    </div>
                    <form id="inventaire" class="o-form js-lpdg-form" action="#" method="post">
                        <div class="o-row -gutter-xs o-form">
                            <div class="o-col w-1/5">
                                <div class="o-form-group__item">
                                    <label class="o-label sr-only" for="marques">Marques</label>
                                    <div class="o-mselect__wrap">
                                        <VueMultiselect selected-label="Actif" v-model="selectedMakes" :options="makes" placeholder="Marque" :multiple="true"></VueMultiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="o-col w-1/5">
                                <div class="o-form-group__item">
                                    <label class="o-label sr-only">Modèles</label>
                                    <div class="o-mselect__wrap">
                                        <VueMultiselect selected-label="Actif" v-model="selectedModels" :options="getModelsForMake(selectedMakes)" placeholder="Modèles" :multiple="true"></VueMultiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="o-col w-1/5">
                                <div class="o-form-group__item">
                                    <label class="o-label sr-only">Type de véhicule</label>
                                    <div class="o-mselect__wrap">
                                        <VueMultiselect selected-label="Actif" v-model="selectedTypes" :options="cats" placeholder="Type de véhicule" :multiple="true"></VueMultiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="o-col w-1/5">
                                <div class="o-form-group__item">
                                    <label class="o-label sr-only">Type de carburant</label>
                                    <div class="o-mselect__wrap">
                                        <VueMultiselect selected-label="Actif" v-model="selectedCarburants" :options="carburants" placeholder="Type de carburant" :multiple="true">
                                            <template #option="props">
                                                <div class="option__desc"><span class="option__title">{{ carburantText[props.option] }}</span></div>
                                            </template>
                                            <template slot="tag" slot-scope="{ option, remove }">
                                                <span class="multiselect__tag"><span>{{ carburantText[option] }}</span> <i @click="remove(option)" aria-hidden="true" tabindex="1" class="multiselect__tag-icon"></i></span>
                                            </template>

                                        </VueMultiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="o-col w-1/5">
                                <div class="o-form-group__item">
                                    <label class="o-label sr-only">Fourchette de prix</label>
                                    <div class="o-mselect__wrap">
                                        <VueMultiselect selected-label="Actif" v-model="selectedRanges" :options="['0-20000','20000-30000','30000-40000','40000-50000','50000-60000','60000-70000','70000-80000','80000-90000','90000-200000']" placeholder="Fourchette de prix" :multiple="true"></VueMultiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div class="o-form__active-filters" style="display:none;" v-show="loaded">

                        <div class="o-form__active-filters__item" v-for="make in selectedMakes">
                            <span class="o-form__active-filters__item__label">{{make}}</span>
                            <button class="o-form__active-filters__item__remove" @click.prevent="removeMake(make)">
                                <svgIco icon="close" />
                            </button>
                        </div>
                        <div class="o-form__active-filters__item" v-for="model in selectedModels">
                            <span class="o-form__active-filters__item__label">{{model}}</span>
                            <button class="o-form__active-filters__item__remove" @click.prevent="removeModel(model)">
                                <svgIco icon="close" />
                            </button>
                        </div>
                        <div class="o-form__active-filters__item" v-for="cat in selectedTypes">
                            <span class="o-form__active-filters__item__label">{{cat}}</span>
                            <button class="o-form__active-filters__item__remove" @click.prevent="removeType(cat)">
                                <svgIco icon="close" />
                            </button>
                        </div>
                        <div class="o-form__active-filters__item" v-for="cat in selectedCarburants">
                            <span class="o-form__active-filters__item__label">{{carburantText[cat]}}</span>
                            <button class="o-form__active-filters__item__remove" @click.prevent="removeCarburant(cat)">
                                <svgIco icon="close" />
                            </button>
                        </div>
                        <div class="o-form__active-filters__item" v-for="cat in selectedRanges">
                            <span class="o-form__active-filters__item__label">{{cat}}</span>
                            <button class="o-form__active-filters__item__remove" @click.prevent="removeRange(cat)">
                                <svgIco icon="close" />
                            </button>
                        </div>

                        <div class="o-form__active-filters__reset" v-if="selectedMakes.length || selectedModels.length || selectedTypes.length || selectedCarburants.length || selectedRanges.length">
                            <button type="button" name="button" class="o-button -reset" @click.prevent="resetSearch">
                                <span class="o-button__text">Réinitialiser</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="o-col w-1/12 -empty"></div>
            </div>
        </div>
    </section>
    <template v-if="!filteredItems.length">
        <section class="o-section">
            <div class="o-container">
                <div class="o-row">
                    <div class="o-col">

                        <h2 class="c-showroom__title">Aucun véhicule trouvé</h2>
                    </div>
                </div>
            </div>
        </section>
    </template>
    <template v-if="filteredMakes.length">
        <template v-for="curMake in filteredMakesData">
            <section class="o-section">
                <div class="o-container">
                    <div class="o-row">
                        <div class="o-col">

                            <h2 class="c-showroom__title">Explorez les modèles {{curMake.name}}</h2>

                            <div class="c-showroom__nav">
                                <button class="c-showroom__nav__item" :class="{'is-active': curMake.showAll}" @click="curMake.showAll=true">
                                    Voir tout
                                </button>
                                <template v-for="cat in curMake.cats">
                                    <button class="c-showroom__nav__item" :class="{'is-active':!curMake.showAll && cat.selected}" @click="cat.selected=true;curMake.showAll=false;checkCat(cat,curMake);">
                                        {{cat.name}}

                                    </button>
                                </template>
                            </div>

                            <div class="c-showroom-cars">

                                <div v-for="item in filteredItemsIn(curMake)" class="js-showroom-car c-showroom-car_item">
                                    <div class="c-showroom-car_image">
                                        <a :href="item.url">
                                            <img :src="item.image" alt="" style="min-width:100%;">
                                        </a>
                                    </div>
                                    <div v-if="item.prev" class="c-showroom-date__wrapper">
                                        <a :href="item.url" class="c-showroom-date -actual">{{item.annee}}</a>
                                        <a :href="item.prev.url" class="c-showroom-date -old">{{item.prev.annee}}</a>
                                        <a v-if="item.prev2" :href="item.prev2.url" class="c-showroom-date -old">{{item.prev2.annee}}</a>

                                    </div>
                                    <div class="c-showroom-car_name">
                                        <a :href="item.url">
                                            {{item.model}}
                                            <span v-if="hasPrix(item)">À partir de {{cash(item.prix)}}</span>
                                        </a>
                                    </div>
                                    <div>
                                        <a :href="item.url" class="c-showroom-car__button">
                                            <span>Choisir</span>
                                            <svgIco icon="arrow-right" />
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <div class="o-container -separator">
                <hr>
            </div>
        </template>
    </template>
</template>
<script>
export default {
    name: 'Showroom',
    
    data() {
        return {
            loaded: true,
            ourl: window.location.href,
            items: lpdgshowroom.items,
            catsId: lpdgshowroom.types,
            carburantsId: lpdgshowroom.carburants,
            makesId: lpdgshowroom.makes,
            cats: Object.keys(lpdgshowroom.types).sort(),
            carburants: Object.keys(lpdgshowroom.carburants).sort(),
            makes: Object.keys(lpdgshowroom.makes).sort(),
            selectedMakes: [],
            selectedModels: [],
            selectedTypes: [],
            selectedCarburants: [],
            selectedRanges: [],
            carburantText: {
                'gas': 'Essence',
                'none': 'Inconnu',
                'hybrid': 'Hybride',
                'recharge': 'Hybride-rechargeable',
                'electric': 'Électrique',
            },
            filteredMakesData: [],
            selectedRanges: []
        }
    },
    computed: {
        filteredItems() {
            return this.items.filter((item) => {
                if (this.selectedMakes.length && !this.selectedMakes.includes(item.make)) return false;
                if (this.selectedModels.length && !this.selectedModels.includes(item.model)) return false;
                if (this.selectedTypes.length && !this._intersec(item.cats, this.selectedTypes)) return false;
                if (this.selectedCarburants.length && !this._intersec(item.carburants, this.selectedCarburants)) return false;
                if (this.selectedRanges.length && !this.priceInRanges(item.prix, this.selectedRanges)) return false;
                return true;
            });
        },
        filteredMakes() {
            var makes = [];
            this.filteredItems.forEach(function (item) {
                makes.push(item.make);
            });
            let tmp = [...new Set(makes)].sort();
            var out = [];
            tmp.forEach((make) => {
                let item = { name: make, showAll: true, cats: [], items: this.filteredItems.filter(function (item) { return item.make == make; }) };
                cats = [];
                item.items.forEach(function (i) {
                    if (i.cats) {
                        i.cats.forEach(function (cat) {
                            if (!cats.includes(cat)) cats.push(cat);
                        });
                    }
                    
                });
                cats.forEach(function (cat) {
                    item.cats.push({ name: cat, selected: false });
                });
                let fixedOrder = [
                    'Compactes & berlines',
                    'Multisegments & VUS',
                    'Camions',
                    'Hybride / électrique',
                    'Sport & coupés'
                ];
                // reorder item.cats with fixedOrder
                item.cats.sort(function (a, b) {
                    return fixedOrder.indexOf(a.name) - fixedOrder.indexOf(b.name);
                });
                out.push(item);
            });
            this.updateURL();
            this.filteredMakesData = out;
            return out;
        }
    },
    methods: {
        _intersec(a1, a2) {
            if (typeof a2 != "object") return false;
            if (typeof a1 != "object") return false;

            var out = a1.filter(function (n) {
                return a2.indexOf(n) !== -1;
            });
            return out.length ? true : false;
        },  

        updateURL() {
            var newurl = '';
            if (this.selectedMakes.length) newurl += '&make=' + this.selectedMakes.join(',');
            if (this.selectedModels.length) newurl += '&model=' + this.selectedModels.join(',');
            if (this.selectedTypes.length) newurl += '&type=' + this.selectedTypes.join(',');
            if (this.selectedCarburants.length) newurl += '&carburant=' + this.selectedCarburants.join(',');
            if (this.selectedRanges.length) newurl += '&range=' + this.selectedRanges.join(',');
            if (newurl) newurl = window.location.href.split('?')[0] + '?' + newurl.substring(1);
            history.replaceState({}, '', newurl);
        },
        resetSearch() {
            this.selectedMakes = [];
            this.selectedModels = [];
            this.selectedRanges = [];
            this.selectedTypes = [];
            this.selectedCarburants = [];

            this.updateURL();
        },
        removeMake(make) {

            this.selectedMakes.splice(this.selectedMakes.indexOf(make), 1);
            this.updateURL();
        },
        removeModel(model) {
            this.selectedModels.splice(this.selectedModels.indexOf(model), 1);
            this.updateURL();
        },
        removeType(type) {
            this.selectedTypes.splice(this.selectedTypes.indexOf(type), 1);
            this.updateURL();
        },
        removeCarburant(carburant) {
            this.selectedCarburants.splice(this.selectedCarburants.indexOf(carburant), 1);
            this.updateURL();
        },
        removeRange(r) {
            this.selectedRanges.splice(this.selectedRanges.indexOf(r), 1);
            this.updateURL();
        },
        hasPrix(item) {
            return item.prix < 250000
        },
        getModelsForMake(makes) {
            if (makes.length == 0) return [];
            var models = [];
            this.items.forEach(function (item) {
                if (makes.includes(item.make)) {
                    models.push(item.model);
                }
            });
            return [...new Set(models)].sort();
        },
        filteredItemsIn(make) {
            return make.items.filter(function (item) {

                if (make.showAll) return true;
                var cat = make.cats.filter(function (c) { return c.selected; })[0];
                if (cat) {
                    if (item.cats.includes(cat.name)) return true;
                    return false;
                }
                return true;
            })
        },
        checkCat(cat, make) {
            make.showAll = false;
            make.cats.forEach(function (c) {
                if (c.name == cat.name) c.selected = true;
                else c.selected = false
            })
            cat.selected = true;
        },
        priceInRanges(prix, ranges) {
            var inRange = false;
            prix = parseInt(prix);
            ranges.forEach(function (r) {
                var range = r.split('-');
                if (prix >= parseInt(range[0]) && prix <= parseInt(range[1])) inRange = true;
            })
            return inRange;
        }
    },
    mounted() {
        var url = new URL(this.ourl);
        var make = url.searchParams.get("make");
        var model = url.searchParams.get("model");
        var type = url.searchParams.get("type");
        var carburant = url.searchParams.get("carburant");
        var range = url.searchParams.get("range");
        if (make) this.selectedMakes = make.split(',');
        if (model) this.selectedModels = model.split(',');
        if (type) this.selectedTypes = type.split(',');
        if (carburant) this.selectedCarburants = carburant.split(',');
        if (range) this.selectedRanges = range.split(',');
    }
}
</script>

 